import { useMemo } from "react";
import { useContext, useEffect } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";
import { LocationFilterButton } from "./LocationFilterParts/LocationFilterButton";

const LocationFilter = ({query, ...props}) => {
	const {
		dictionaryWords,
		sportsCamps,

		locationCounter,
		setLocationCounter,

		locations,
		setLocations,
		locationButtonsActive,
		setLocationButtonsActive,
	} = useContext(SportsCampsContext);

	const handleChange = (location, index) => {
		let copy = [...locationButtonsActive];
		let current = copy[index];
		current = !current;
		copy[index] = current;
		setLocationButtonsActive(copy);

		if (current === true) {
			setLocations([...locations, location]);
		} else if (current === false) {
			setLocations(locations.filter((item) => item !== location));
		}
	};

	useEffect(() => {
		if (sportsCamps.counters) {

			const locationCounters = [];

			sportsCamps.counters.forEach((Type) => {
				if (Type.Type === "location") {

					const object = {
						Location: Type.LocationName,
						Count: Type.Count
					};

					locationCounters.push(object);
				}

			});

			setLocationCounter(locationCounters);
		}

	}, [JSON.stringify(sportsCamps.counters)]);

	useEffect(() => {
		if (query) {
			var actives = query.split(',');
			if(locationCounter && locationCounter.length > 0) {
				locationCounter.forEach((lc, i) => {
					if (actives.includes(lc.Location)) {
						handleChange(lc.Location, i);
					}
				});
			}
		}
	}, [query, JSON.stringify(locationCounter)]);

	//Rerender buttons on locationCounter & locationbuttons change
	const filterButtons = useMemo(() => {
		if(locationCounter && locationCounter.length > 0) {
			return locationCounter.map((object, index) => (
				(object.Count && object.Count > 0) ? <LocationFilterButton
					key={object.Location}
					object={object}
					index={index}
					handleClick={handleChange}
					isActive={locationButtonsActive[index]} /> : null
			));
		}
	}, [JSON.stringify(locationCounter), JSON.stringify(locationButtonsActive)]);

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.location}</h3>
			{sportsCamps.counters && filterButtons}
		</div>
	);
};

export default LocationFilter;
